<template>
  <div class="flex w-full items-center justify-between border-b p-3">
    <button @click.prevent="emit('navigate:back')">
      <icon-base
        :icon="IconShrinkWhite"
        height="21"
        width="21"
        icon-color="none"
      />
    </button>
    <div
      v-if="type === AiDialogType.AgentChat"
      class="flex w-full items-center justify-center space-x-1"
    >
      <icon-base
        :icon="IconAINav"
        class="text-label"
        width="16"
        height="16"
        view-box="0 0 30 30"
      />
      <lf-h4 v-tooltipable class="max-w-1/3 truncate">
        {{
          agentSessionInfo.activeSession?.agent?.name ??
          $t("WORKFLOWS.WORKFLOW_BUILDER.AI_AGENT")
        }}
      </lf-h4>
      <span
        v-if="
          agentSessionInfo.activeSession?.application_name ||
          agentSessionInfo.activeSession?.application_id
        "
      >
        &bull;
      </span>
      <lf-h4
        v-if="agentSessionInfo.activeSession?.application_name"
        v-tooltipable
        class="max-w-1/3 truncate"
      >
        {{ agentSessionInfo.activeSession.application_name }}
      </lf-h4>
      <copy-to-clipboard-button
        v-if="agentSessionInfo.activeSession?.application_id"
        :value="agentSessionInfo.activeSession.application_id"
        :show-tooltip="false"
        :icon="IconLink"
      />
    </div>
    <div class="flex items-center space-x-1">
      <pin-button v-if="type === AiDialogType.AgentChat" />
      <button @click.prevent="emit('modal:close')">
        <icon-base :icon="IconX" class="text-label" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";

import { AiDialogType } from "@/enums/ai";
import { useAiAgentsStore } from "@/stores/ai/agents";

import CopyToClipboardButton from "@/components/CopyToClipboardButton.vue";
import PinButton from "@/components/cmdK/PinButton.vue";
import IconAINav from "@/components/icons/IconAINav.vue";
import IconLink from "@/components/icons/IconLink.vue";
import IconShrinkWhite from "@/components/icons/IconShrinkWhite.vue";
import IconX from "@/components/icons/deals/IconX.vue";
import IconBase from "@/components/ui/IconBase.vue";
import LfH4 from "@/components/ui/text/LfHeading4.vue";

const { type } = defineProps<{
  type: AiDialogType;
}>();

const { agentSessionInfo } = storeToRefs(useAiAgentsStore());

const emit = defineEmits<{ "modal:close": []; "navigate:back": [] }>();
</script>
